export const reportButtonStyles = {
    button: 'btn btn-default line small',
};
